import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-circulars',
  templateUrl: './exam-circulars.component.html',
  styleUrls: ['./exam-circulars.component.scss']
})
export class ExamCircularsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
